import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector } from 'react-redux';
import { infiniteScrollItemsFetchLimit as fetchLimit } from '@app/helpers';
import { IActiveFilter } from '@app/models';

interface IProps {
    totalCount: number;
    currentCount: number;
    onFetch: Function;
    children: JSX.Element;
    resetLocal?: number;
    height?: string | number;
}

export const PasslyInfiniteScroll = (props: IProps) => {
    const { totalCount, currentCount, onFetch, children, resetLocal } = props;

    const [scrollCount, setScrollCount] = useState<number>(0);

    const [randomId] = useState<string>('scrollableArea' + Math.floor(Math.random() * 10000));

    const organizationChange = useSelector((state: any) => state.organizationSelect.selectedOrganization);
    const selectedJitOrganization = useSelector((state: any) => state.organizationSelect.selectedJitOrganization);
    const activeFilters: IActiveFilter[] = useSelector((state: any) => state.listPageBar.activeFilters);
    const orderDirection = useSelector((state: any) => state.listPageBar.direction);
    const orderProperty = useSelector((state: any) => state.listPageBar.property);
    const resetScroll = useSelector((state: any) => state.basic.resetScroll);

    useEffect(() => {
        if (organizationChange || selectedJitOrganization || (resetLocal !== undefined && resetLocal > 0)) {
            fetchMore(true);
        }
    }, [organizationChange, selectedJitOrganization, activeFilters, orderDirection, orderProperty, resetScroll, resetLocal]);

    const fetchMore = (isReset?: boolean) => {
        let nextScrollCount = scrollCount + fetchLimit;
        let countToUse = isReset ? 0 : scrollCount;

        onFetch(countToUse, isReset);

        isReset ? setScrollCount(fetchLimit) : setScrollCount(nextScrollCount);
    };

    return (
        <div id={randomId} className='scrollableTable'>
            <InfiniteScroll
                dataLength={currentCount}
                hasMore={currentCount < totalCount}
                next={fetchMore}
                loader={<></>}
                scrollableTarget={randomId}
                scrollThreshold='93%'
                {...props}
            >
                {children}
            </InfiniteScroll>
        </div>
    );
};
